/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementLinkIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ElementLinkIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.64643 3.64667C9.67012 2.62298 11.3298 2.62298 12.3535 3.64667C13.3772 4.67036 13.3772 6.33009 12.3535 7.35378L11.3535 8.35378L10.6464 7.64667L11.6464 6.64667C12.2796 6.01351 12.2796 4.98695 11.6464 4.35378C11.0133 3.72062 9.9867 3.72061 9.35354 4.35378L8.35354 5.35378L7.64643 4.64667L8.64643 3.64667ZM6.35354 7.35378L5.35354 8.35378C4.72037 8.98695 4.72037 10.0135 5.35354 10.6467C5.9867 11.2798 7.01326 11.2798 7.64643 10.6467L8.64643 9.64667L9.35354 10.3538L8.35353 11.3538C7.32984 12.3775 5.67012 12.3775 4.64643 11.3538C3.62274 10.3301 3.62274 8.67036 4.64643 7.64667L5.64643 6.64667L6.35354 7.35378ZM7.35354 9.35378L10.3535 6.35378L9.64643 5.64667L6.64643 8.64667L7.35354 9.35378Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ElementLinkIcon.tags = [
  'link',
  'chain',
  'connection',
  'attach',
  'unite',
  'hyperlink',
];

ElementLinkIcon.category = 'Navigator';

ElementLinkIcon.iconSize = 16;
